import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNote1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="note-1"><path fillRule="evenodd" clipRule="evenodd" d="M3 6.75C3 4.67893 4.67893 3 6.75 3H17.25C19.3211 3 21 4.67893 21 6.75V14.5H18.25C16.1789 14.5 14.5 16.1789 14.5 18.25V21H6.75C4.67893 21 3 19.3211 3 17.25V6.75Z" fill="currentColor"/><path d="M16 20.7881C16.5252 20.6037 17.0079 20.3028 17.409 19.9016L19.9016 17.409C20.3028 17.0079 20.6037 16.5252 20.7881 16H18.25C17.0074 16 16 17.0074 16 18.25V20.7881Z" fill="currentColor"/></CentralIconBase>;
};

export default IconNote1;
